import Header from './header';
import About from './about';
import ServicesProducts from './services-products';
import Customers from './customers';
import Screen from '../../components/screen';
import Purpose from './purpose';

export default function HomePage() {
	return (
		<Screen>
			<Header/>
			<About/>
			<Purpose/>
			<ServicesProducts/>
			<Customers/>
		</Screen>
	)
}